import React, { useState } from "react";
import { CiShare2 } from "react-icons/ci";
import { FaDesktop, FaMobileAlt, FaShoppingCart } from "react-icons/fa";
import { FaAndroid, FaGlobe, FaUserTie } from "react-icons/fa6";

const ShareAppCode = () => {
  const [activeTab1, setActiveTab1] = useState("web");
  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];
  const content1 = {
    web: "",
    mobile: "",
  };
  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
              ? "bg-[#1a9588] text-white shadow-md"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">
      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <CiShare2 className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Share App Code</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          {/* Seller Tag */}
          <span className="flex items-center gap-2 bg-pink-100 text-pink-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-pink-200 transition">
            <FaUserTie className="text-pink-600" />
            Seller
          </span>

          <span className=" flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
            <FaShoppingCart className="text-green-600" />
            Buyer
          </span>
        </div>

        <div className="flex flex-wrap gap-3">
          {/* Web Tag */}
          <span className="flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-blue-200 transition">
            <FaGlobe className="text-blue-600" />
            Web
          </span>

          {/* Android Tag */}
          <span className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
            <FaAndroid className="text-green-600" />
            Android
          </span>
        </div>
      </div>

      <p className="text-start mb-6 text-gray-600  leading-relaxed">
        Once your Selzor account is set up to receive orders, the first step is
        to invite your wholesale buyers. We offer a standard invitation template
        that includes your Company Name and Selzor App Code. Distributors are
        also included, with a tailored invitation template showcasing their
        Company Name and Distributor Code.
        <br />
        <br />
        On the Selzor mobile apps, you can send these invitations with a single
        tap via WhatsApp or iMessage.
        <br />
        <br />
        We recommend sharing this invitation banner with your wholesale
        customers through WhatsApp, email, or social media channels.
      </p>

      <div className="my-5">
        {renderTabs(activeTab1, setActiveTab1)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={content1[activeTab1]}
            alt={`${activeTab1} view`}
            className="rounded-lg  max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ShareAppCode;
